import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch colleges
export const fetchAllColleges = createAsyncThunk(
    'colleges/fetchAllColleges',
    async (_, { rejectWithValue }) => {
        try {
            await new Promise((resolve) => setTimeout(resolve, 500)); // Force delay
            const response = await axios.get('api/v1/only_colleges_fetch');
            return response.data.colleges || [];
        } catch (err) {
            console.error('Failed to fetch colleges:', err);
            return rejectWithValue(err.response?.data || 'Unknown error');
        }
    }
);

const collegesSlice = createSlice({
    name: 'colleges',
    initialState: {
        allColleges: [],
        loading: false,
        error: null,
    },
    reducers: {
        setAllColleges(state, action) {
            state.allColleges = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllColleges.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllColleges.fulfilled, (state, action) => {
                state.loading = false;
                state.allColleges = action.payload;
            })
            .addCase(fetchAllColleges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setAllColleges } = collegesSlice.actions;
export default collegesSlice.reducer;
